var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"size":"small","clearable":"","filterable":"","placeholder":"请输入关键字或选择"},on:{"change":_vm.onChange}},_vm._l((_vm.list.items),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }